var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "keyword-chip",
    class: _vm.listMode ? 'd-block' : 'd-inline',
    on: {
      "click": function ($event) {
        return _vm.toggleKeyword(_vm.keyword);
      }
    }
  }, [!_vm.isPlusButton ? _c('v-chip', {
    staticClass: "text mb-4",
    class: {
      'keyword-chip-item-big': _vm.isBigMode,
      'primary-surface': _vm.isKeywordSelected,
      'text-l-small-regular': !_vm.isBigMode,
      'text-l-large-regular': _vm.isBigMode,
      clickable: _vm.currentUser && !_vm.isSpecialRequirement,
      'keyword-chip-item-break-line': !_vm.truncateText && _vm.isGreaterThanContainer,
      'keyword-chip-item': _vm.truncateText
    },
    attrs: {
      "id": _vm.getId,
      "label": "",
      "text-color": _vm.isKeywordSelected ? 'primary' : 'grey darken-3',
      "outlined": _vm.isKeywordSelected,
      "color": _vm.backgroundColor
    }
  }, [_vm.$breakpoint.tabletAndDown ? _c('span', {
    class: {
      'text-truncate': _vm.truncateText
    }
  }, [_vm._v(" " + _vm._s(_vm.keyword) + " ")]) : _vm._e(), _vm.$breakpoint.smallDesktopAndUp ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('span', _vm._g(_vm._b({
          class: {
            'text-truncate': _vm.truncateText
          }
        }, 'span', attrs, false), on), [_vm._v(_vm._s(_vm.keyword))])];
      }
    }], null, false, 3262792238)
  }, [_c('span', [_vm._v(_vm._s(_vm.keyword))])]) : _vm._e(), !_vm.isSpecialRequirement ? _c('div', [_vm.isKeywordSelected && _vm.currentUser ? _c('ph-x', {
    staticClass: "ml-2",
    class: {
      clickable: _vm.currentUser
    },
    attrs: {
      "weight": "thin",
      "size": "18",
      "color": "var(--v-primary-base)"
    }
  }) : _vm._e(), !_vm.isKeywordSelected && _vm.currentUser ? _c('ph-plus', {
    staticClass: "ml-2",
    class: {
      clickable: _vm.currentUser
    },
    attrs: {
      "weight": "thin",
      "size": "18",
      "color": "var(--v-grey-darken3)"
    }
  }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm.isPlusButton ? _c('v-chip', {
    staticClass: "keyword-chip-item text text-l-small-regular mb-4 clickable",
    attrs: {
      "label": "",
      "color": "white",
      "text-color": "grey darken-3"
    },
    on: {
      "click": _vm.showMoreInterests
    }
  }, [_vm._v(" +" + _vm._s(_vm.collapsedNumberOfKeywords) + " interests ")]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }